import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ n, children }) => (
  <Reveal>
    <p className="font-display text-xs font-bold uppercase tracking-[0.35em] text-nora-ink/45">
      {n} · {children}
    </p>
  </Reveal>
);
